import axios from "axios";
import { environment } from "../config.env";

const domain =
  process.env.REACT_APP_ENDPOINT_DOMAIN || environment.endpoint_domain || "";

export const checkInformation = ( pid ) => {

  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/register/check_information`;
    let header = {
      "Content-Type": "application/json",
    };

    const body = {
      pid: pid.pid,
      role: pid.role
    }

    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export const registerPatient = (body) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/register/patient`;
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};
export const registerMedicalPersonnel = (body) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/register/medicalPersonnel`;
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};
export const registerHospitalPersonnel = (body) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/register/hospitalPersonnel`;
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export function postRequireOTP(phone, uid) {
  return new Promise((resolve) => {
    const path = "/api/v1/hospital_personal/otp/send_otp";
    let body = {
      phone,
      uid,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        // console.log(error);
      });
  });
}

export function postVerifyOTP(id, otp) {
  return new Promise((resolve) => {
    const path = "/api/v1/hospital_personal/otp/verify_otp";
    let body = {
      otp,
      id,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(path, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        resolve(false);
        // console.log(error);
      });
  });
}

export const registerLaboratoryAdmin = (body) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/register/laboratoryAdmin`;
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};
export const registerLaboratoryPersonnel = (body) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/register/laboratoryPersonnel`;
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const getLaboratoryList = (data) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/laboratory/getLaboratoryList${
      data ? `?district_id=${data}` : ""
    }`;
    axios
      .get(url)
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const getProvinceList = (healthAreaId) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/address/getProvinceList`;
    url += `?health_area_id=${healthAreaId}`;
    axios
      .get(url)
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};
export const getDistrictList = (provinceId) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/address/getDistrictList`;
    url += `?province_id=${provinceId}`;
    axios
      .get(url)
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};
export const getSubDistrictList = (districtId) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/address/getSubDistrictList`;
    url += `?district_id=${districtId}`;
    axios
      .get(url)
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};
export const getHospitalList = (districtId) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/hospital/getHospitalList`;
    axios
      .get(url)
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};
export const searchSubDistrict = (sub_district_name) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/address/searchSubDistrict`;
    let body = {
      sub_district_name: sub_district_name,
    };
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const attachment = (formDataBody) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/file/attachment`;
    let header = {
      "Content-Type": "multipart/form-data",
    };
    axios
      .post(url, formDataBody, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};
export const resetPassword = (body) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/password/resetPassword`;
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const forgotPassword = (body) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/forgot-password/phone-number`;
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const requestOtp = (body) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/forgot-password/otp`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("forgot_password_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const verifyOtp = (body) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/forgot-password/otp/confirm`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("forgot_password_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const setNewPassword = (body) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/forgot-password/set-password`;
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("forgot_password_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const searchResult = (pid) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/laboratory/searchResult`;
    let body = {
      pid: pid,
    };
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const getContentList = (body) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/content/list`;
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const getFormSurveyList = (body) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/form_survey/list`;
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .get(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const getContentDetail = (content_id) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/content/detail/${content_id}`;
    let body = {};
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .get(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const getAnnouncementPublic = (page, number_per_page) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/announcement/getAnnouncement`;
    let body = {
      page: page,
      number_per_page: number_per_page,
    };
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export const addPetition = (formState) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/petition/addPetition`;
    let body = {
      pid: formState.pid,
      fname: formState.fname,
      lname: formState.lname,
      phone_number: formState.phone_number,
      hospital_name: formState.hospital_name,
    };
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

export function getOauthUrl() {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/thaid/getOauthUrl/web`;
    axios
      .get(url)
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getOauthUrlThaiID(role) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/thaid/getOauthUrlThaiID/web/${role}`;
    axios
      .get(url)
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function loginThaiD(code) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/auth/loginThaiD/web`;
    let body = {
      code: code,
    };
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function loginThaiDWithRole(code, roleName) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/auth/loginThaiD/web/${roleName}`;
    let body = {
      code: code,
      role: roleName,
    };
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

// ประชาสัมพันธ์
export function getNews(body) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/content/list`;
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

// ความพึงพอใจการใช้เว็บไซด์
export function addQuestionnaire(title, rating, comment) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/rating/add-rating`;
    let body = {
      survey: title,
      comment: comment,
      rating: rating,
    };
    let header = {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("pg_access_token"),
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}
export function getQuestionnaire() {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/questionnaire/rating`;
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getFAQ(page, number_per_page, title) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/faq${
      title ? `?title=${encodeURIComponent(title)}` : ``
    }`;
    // let body = {
    //   title,
    //   page,
    //   number_per_page,
    // };
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .get(url, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getQuestionnaires(page, number_per_page, title) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/questionnaire/get-questionnaire`;
    let body = {
      title,
      page,
      number_per_page,
    };
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function submitQuestionnaires(data) {
  return new Promise((resolve) => {
    let token = localStorage.getItem("pg_access_token");
    let url = `${domain}/api/v1/public/questionnaire/submitAnswer`;
    let body = data;
    let header = token
      ? {
          "Content-Type": "application/json",
          Authorization: token,
        }
      : {
          "Content-Type": "application/json",
        };
    // console.log(body);
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getMenuNav(role) {
  // console.log(role);
  return new Promise((resolve) => {
    let token = localStorage.getItem("pg_access_token");
    // console.log(token);
    let url = `${domain}/api/v1/public/menu/getMenuNav`;
    let body = { role: role ?? "PUBLIC" };
    let header = token
      ? {
          "Content-Type": "application/json",
          Authorization: token,
        }
      : {
          "Content-Type": "application/json",
        };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export function getContact(page, number_per_page) {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/contact/get-contact`;
    let body = {
      page,
      number_per_page,
    };
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}



export function getInspectionStatistics() {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/content/lab-information-one-month-back`;
    axios
      .get(url)
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
}

export const getBannerList = (body) => {
  return new Promise((resolve) => {
    let url = `${domain}/api/v1/public/banner/list`;
    let header = {
      "Content-Type": "application/json",
    };
    axios
      .post(url, body, { headers: header })
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

